var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 16V6.5C19 5.6875 18.3125 5 17.5 5H7.5C6.09375 5 5 6.125 5 7.5V18.5C5 19.9062 6.09375 21 7.5 21H18.25C18.6562 21 19 20.6875 19 20.25C19 19.8438 18.6562 19.5 18.25 19.5H18V17.4375C18.5625 17.2188 19 16.6562 19 16ZM16.5 19.5H7.5C6.9375 19.5 6.5 19.0625 6.5 18.5C6.5 17.9688 6.9375 17.5 7.5 17.5H16.5V19.5ZM17.5 16H7.5C7.125 16 6.78125 16.0938 6.5 16.2188V7.5C6.5 6.96875 6.9375 6.5 7.5 6.5H17.5V16ZM12.1875 14.375C12.3438 14.5625 12.625 14.5625 12.7812 14.375L15.4375 11.7188C16.2188 10.9375 16.1562 9.65625 15.3125 8.9375C14.5625 8.3125 13.4375 8.40625 12.75 9.09375L12.4688 9.375L12.2188 9.09375C11.5312 8.40625 10.4062 8.3125 9.65625 8.9375C8.8125 9.65625 8.75 10.9375 9.53125 11.7188L12.1875 14.375Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/Book.a6dbc805b0c05cc50585e12d5f696220.svg";
export { ForwardRef as ReactComponent };